import CustomerChat from 'pages/chats/CustomerChat';
import React from 'react';

const Chats = (): JSX.Element => (
  <div>
    <CustomerChat />
  </div>
);

export default Chats;
